import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { UpdateKeyValueAsync } from "source/app/infrastructure/Data/KeyValues/UpdateKeyValue";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { CanSetState } from "source/app/services/UI/State/SetState";


export async function SetValueAsync(
    newValue: number,
    sharedFunction: ESharedFunction
) {
    const keyValue = ReadState<IKeyValue>(sharedFunction);

    if (keyValue && CanSetState(sharedFunction)) {
        const newValueString = newValue.toString();
        await UpdateKeyValueAsync(sharedFunction, newValueString);
    }
}
